import styled from '@emotion/styled'

const activeStyles = (theme) => `
  cursor: pointer;

  svg {
    color: ${theme.colors.text};
  }
`

const inactiveStyles = (theme) => `
  cursor: default;

  svg {
    color: ${theme.colors.lightGray};
  }
`

const Wrapper = styled.div`
  ${({ inactive, theme }) =>
    inactive ? inactiveStyles(theme) : activeStyles(theme)}
  display: inline-block;
  height: ${({ size }) => size};
  overflow: hidden;
  width: ${({ size }) => size};

  svg {
    transform: scale(1);
  }
`

const Icon = ({ children, className, inactive, size }) => (
  <Wrapper className={className} inactive={inactive} size={size}>
    {children}
  </Wrapper>
)

Icon.defaultProps = {
  className: '',
  inactive: false,
  size: '20px',
}

export default Icon
